import styled from '@emotion/styled';
import { css } from '@emotion/react';
import { Flex } from 'lib/components/Flex';
import { TrendBase } from '../Trend/Trend.styles';

const addHasTrend = (p) =>
    p.hasTrend &&
    css`
        & > div:first-of-type {
            flex: 2;
        }
    `;

export const MetricItemBase = styled(Flex)`
    align-items: flex-end;
    background: ${(p) => p.theme.color.grayDark2};
    width: 100%;
    min-height: 65px;
    text-wrap-mode: nowrap;
    align-items: center;

    & ${TrendBase} {
        margin-top: 20px;
        @media (max-width: ${(p) => p.theme.breakpoint.desktop}px) {
            margin-top: 18px;
        }
    }

    & > div {
        flex: 1;
    }
    ${addHasTrend};
`;
